import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import classNames from 'classnames';
import Container from '../Utils/Container/Container';
import { SectionTitleAlignment } from '../../interfaces/enums/SectionTitleAlignment';
import Subtitle from '../Subtitle/Subtitle';
import Heading, { HeadingTypes } from '../Heading/Heading';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import RichText from '../RichText/RichText';
import { StoryblokComponent } from 'gatsby-source-storyblok';

interface SectionTitleProps {
  subtitle?: string;
  title?: string;
  body?: StoryblokRichtext;
  cta?: Blok[];
  alignment: SectionTitleAlignment;
  is_top_padding_required?: boolean;
  container?: string;
  anchor_id?: string;
}

enum ContainerWidth {
  WIDE = 'wide',
  TIGHT = 'tight',
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  subtitle = undefined,
  title,
  body = undefined,
  cta = [],
  alignment,
  is_top_padding_required = true,
  container,
  anchor_id,
}) => {
  return (
    <Container enable={container !== ContainerWidth.WIDE} id={anchor_id}>
      <div
        className={classNames(
          'flex flex-col items-center justify-center gap-y-6 text-center',
          {
            'pt-12 sm:pt-16 lg:pt-20 xl:pt-28': is_top_padding_required,
            'lg:flex-row lg:justify-between lg:gap-y-0 lg:gap-x-6 lg:text-left':
              alignment === SectionTitleAlignment.Left,
          }
        )}
      >
        <div className="flex flex-col gap-y-2">
          {subtitle && <Subtitle text={subtitle} />}
          {title && <Heading text={title} headingType={HeadingTypes.h2} />}
          {body && <RichText content={body} />}
        </div>
        {cta.map((cta_item: Blok) => (
          <div className="w-full sm:w-auto" key={cta_item._uid}>
            <StoryblokComponent blok={{ ...cta_item, size: ButtonSize.XL }} />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default memo(SectionTitle);
